module.exports = __webpack_public_path__ + "img/cocolife.538600c6.png";